<script>
    import MapUtilities from '../../modules/MapUtilities';
    import { logLocationView } from '../../modules/mixpanel';

    export default {
        name: 'location',

        props: {
            space: Object,
        },

        data() {
            return {
                activeTab: 'details',
            };
        },

        computed: {
            mapMarker() {
                return MapUtilities.get('listingIcon');
            },

            whitelabelMarker() {
                return MapUtilities.get('partnerIcon');
            },
        },

        mounted() {
            this.logSpaceView();
        },

        methods: {
            scrollToReviews() {
                if (this.$isPartner) {
                    return this.selectTab('reviews');
                }

                $('html, body').stop().animate({
                    scrollTop: $('#reviews').offset().top - 50,
                }, 1000);
            },

            selectTab(tabName) {
                this.activeTab = tabName;
            },

            /**
             * logs space views to mixpanel
             */
            logSpaceView() {
                logLocationView({
                    page: 'Space Details Page',
                    title: this.space.title,
                    review_count: this.space.reviews.count,
                    review_average: this.space.reviews.average,
                    price: this.space.price_from,
                    id: this.space.id,
                });
            },

            /**
             * Return the external streetview url.
             *
             * @returns {string}
             */
            getStreetViewLink({ lat, lng, heading, pitch }) {
                const params = Object.entries({
                    viewpoint: [lat, lng].join(','),
                    heading: heading,
                    pitch: pitch,
                }).map((parts) => parts.join('=')).join('&');

                return `https://www.google.com/maps/@?api=1&map_action=pano&${ params }`;
            }
        },
    };
</script>
